const FormInput = ({ label, name, type = 'number', value, onChange, placeholder, unit = '', disabled = false }) => (
    <div className="flex flex-col">
        <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1 flex items-center">
            {label}
        </label>
        <div className="relative">
            <input
                type={type}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                onWheel={(e) => e.target.blur()}
                placeholder={placeholder || `Enter ${label.toLowerCase()} ${unit ? 'in ' + unit : 'count in number'}`}
                className={`mt-1 p-3 border h-full border-gray-300 rounded-md shadow-sm block w-full sm:text-sm pr-10
                ${disabled ? 'bg-gray-100 cursor-not-allowed text-gray-500' : 'focus:ring-blue-500 focus:border-blue-500'}`}
                disabled={disabled}
                required
            />
            {unit && (
                <span
                    className="mt-1 absolute top-0 right-0 h-full flex items-center px-3 bg-gray-500 text-white text-sm font-medium"
                    style={{ borderBottomRightRadius: '0.375rem', borderTopRightRadius: '0.375rem' }}
                >
                    {unit}
                </span>
            )}
        </div>
    </div>
);


export default FormInput;
